// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--3XC-b","title":"title--oEsWx","info":"info--1dT3y"};